import { getPredictorsTop } from "@/services/getPredictorsTop";
import { IPredictorProfiles, IPredictorRefinedProfile } from "@/types/IPredictorProfiles";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PredictorsState {
    profiles: IPredictorRefinedProfile[];
    pageNumber: number;
    loading: boolean;
    error: string | null;
    hasMore: boolean;
    reset: boolean;
    searchString: string;
}

const initialState: PredictorsState = {
    profiles: [],
    pageNumber: 0,
    loading: false,
    error: null,
    hasMore: true,
    reset: false,
    searchString: ""
};

export const fetchTopPredictors = createAsyncThunk(
    "explore/predictorsSlice",
    async (
        { pageNumber, filterValue }: { pageNumber: number; filterValue: string },
        { rejectWithValue }
    ) => {
        try {
            const data = await getPredictorsTop(pageNumber, filterValue);
            return data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const PredictorsSlice = createSlice({
    name: "predictors_slice",
    initialState,
    reducers: {
        resetExplore: (state) => {
            state.pageNumber = 0;
            state.profiles = [];
            state.hasMore = true;
        },
        setReset: (state, action: PayloadAction<boolean>) => {
            state.reset = action.payload;
        },
        incrementPageNumberExplore: (state) => {
            state.pageNumber += 1;
        },
        resetPageNumber: (state) => {
            state.pageNumber = 0;
            state.hasMore = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTopPredictors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTopPredictors.fulfilled, (state, action: PayloadAction<IPredictorProfiles[]>) => {
                state.loading = false;
                const newProfiles = action.payload;
                const filteredProfiles: IPredictorRefinedProfile[] = [];
                // for (let i = 0; i < newProfiles?.length; i++) {
                // filteredProfiles.push({
                //     sr_type: 0,
                //     sr_id: 0,
                //     profile_id: newProfiles[i].predictor_data.outId,
                //     profile_displayname: newProfiles[i].predictor_data.displayName,
                //     profile_handle: newProfiles[i].predictor_data.handle,
                //     profile_profilepic: newProfiles[i].predictor_data.profilePic,
                //     profile_followcheck: newProfiles[i].predictor_data.followCheck,
                //     profile_followsme: newProfiles[i].predictor_data.followsMe,
                //     prediction_amount:  newProfiles[i].prediction_amount,
                //     predictor:  newProfiles[i].predictor,
                //     score_change:  newProfiles[i].score_change,
                //     profile_score : newProfiles[i].score,
                //     profile_isgoat : newProfiles[i].predictor_data.isPredictorGoat ? 1 : 0
                // })

                // }
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "LiτBiτ",
                    profile_handle: "LiτBiτ",
                    profile_profilepic: "https://pbs.twimg.com/profile_images/1907959752476254208/w8yXHgPz.jpg",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 3,
                    score_change: -158.90,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$MOVE X390"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "MK Marshall",
                    profile_handle: "MK Marshall",
                    profile_profilepic: "https://outprofilecontent.s3.eu-north-1.amazonaws.com/profilepics/0/5958/8508120760234769036.png",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 49,
                    score_change: 105,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$GYAT X120"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "blknoiz06",
                    profile_handle: "blknoiz06",
                    profile_profilepic: "https://pbs.twimg.com/profile_images/1909437863592132608/R14kQm8j.jpg",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 18,
                    score_change: 94.37,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$WIF X60"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "RookieXBT",
                    profile_handle: "RookieXBT",
                    profile_profilepic: "https://pbs.twimg.com/profile_images/1868604017267331072/M37uiWtv_400x400.jpg",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 6,
                    score_change: 65.01,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$FARTCOIN X30"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "TysonThe2nd",
                    profile_handle: "TysonThe2nd",
                    profile_profilepic: "https://outprofilecontent.s3.eu-north-1.amazonaws.com/profilepics/0/104/1790580966301566507.png",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 7,
                    score_change: 47.23,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$TIBBIR X26"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "Rich",
                    profile_handle: "Rich",
                    profile_profilepic: "https://outprofilecontent.s3.eu-north-1.amazonaws.com/profilepics/0/2205/3674632638316015164.png",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 20,
                    score_change: -29.08,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$Satya X18"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "Comet",
                    profile_handle: "Comet",
                    profile_profilepic: "https://outprofilecontent.s3.eu-north-1.amazonaws.com/profilepics/2/21319/1714722302026174536.png",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 37,
                    score_change: 28.14,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$WHITE X12"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "Funnymemes",
                    profile_handle: "Funnymemes",
                    profile_profilepic: "https://outprofilecontent.s3.eu-north-1.amazonaws.com/profilepics/2/22569/7809381762515591370.png",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 25,
                    score_change: 23,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$ENA X8"
                })
                filteredProfiles.push({
                    sr_type: 0,
                    sr_id: 0,
                    profile_id: -1,
                    profile_displayname: "Bryan Johnson",
                    profile_handle: "Bryan Johnson",
                    profile_profilepic: "https://abs.twimg.com/sticky/default_profile_images/default_profile.png",
                    profile_followcheck: 0,
                    profile_followsme: 0,
                    prediction_amount: 17,
                    score_change: 47.23,
                    profile_score: 0,
                    profile_isgoat: 0,
                    predictor: 1,
                    greatest_call: "$WIF X50"
                })
                // let newData = state.pageNumber === 0 ? [...filteredProfiles] : [...state.profiles, ...filteredProfiles]
                // const uniqueData = newData.filter((v, i, a) => a.findIndex(t => (t.profile_id === v.profile_id)) === i)
                // state.profiles = uniqueData;
                state.profiles = filteredProfiles;
                if (newProfiles?.length === 0) {
                    state.hasMore = false;
                }
            })
            .addCase(fetchTopPredictors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
    },
});

export const {
    incrementPageNumberExplore,
    resetExplore,
    setReset,
    resetPageNumber
} = PredictorsSlice.actions;

export default PredictorsSlice.reducer;